import React from 'react';
import PropTypes from 'prop-types';
import useSWR from 'swr';
import UpsellCard from '../UpsellCard/UpsellCard';
import { platform_base_url } from '../../util/config';
import { get } from '../../util/request';
import * as Styled from './UpsellCollection.styled';

/**
 * `UpsellCollection` displays a product-only Shopify collection as a list of `UpsellCard`.
 */
const UpsellCollection = ({ id, onComplete, heading, subtitle, ...props }) => {
  const { data, error } = useSWR(
    id ? `${platform_base_url}/v1/collections?shopify_ids=${id}` : null,
    get
  );

  if (error) return <div>Something went wrong.</div>;
  if (!data?.collections?.[0]?.components?.[0]?.components) return null;

  return (
    <section {...props}>
      <Styled.Heading>{heading}</Styled.Heading>
      {subtitle && <Styled.Subtitle>{subtitle}</Styled.Subtitle>}
      <Styled.CardContainer>
        {data.collections[0].components[0].components.map(
          ({ title, variants, images, tags, id: productId }) => (
            <UpsellCard
              title={title}
              subtitle={
                !tags?.includes('template:giftcard') ? variants[0].title : null
              }
              image={images[0]?.src_transparent || images[0]?.src}
              price={variants[0].price.replace(/\.00$/, '')}
              variantId={variants[0].id}
              isAvailable={variants[0].available}
              key={variants[0].id}
              onComplete={onComplete}
              productId={productId}
            />
          )
        )}
      </Styled.CardContainer>
    </section>
  );
};

UpsellCollection.propTypes = {
  /**
   * Shopify Collection Id for products to display.
   */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Pass-through callback for successful UpsellCard request
   */
  onComplete: PropTypes.func,
  /**
   * Heading for the collection
   */
  heading: PropTypes.string,
  /**
   * optional subtitle for the collection
   */
  subtitle: PropTypes.string
};

UpsellCollection.defaultProps = {
  id: null,
  onComplete: null,
  heading: 'Upgrade Your Wrapping',
  subtitle: 'FYI, socks and shirts sold separately.'
};

export default UpsellCollection;
